import { ComponentType, PropertyConfigEntity } from '@/interfaces';
import { InputType } from '@amili-v3/amili-v3-design';
import { BaseOptionType, DefaultOptionType } from 'antd/es/select';
import unionBy from 'lodash/unionBy';

type ConfigPayloadEntity = {
  inputType: InputType | undefined;
  customKey: string;
  dataConfig: Record<string, PropertyConfigEntity<ComponentType>>;
  options: BaseOptionType[] | undefined;
  isPreventCustomConfig: boolean;
};

const TYPES_ALLOW_CUSTOM_OPTS: InputType[] = [
  'select',
  'checkboxGroup',
  'auto-complete',
  'radioGroup',
];

//Customized options base on config data options from db config
export const transformOptionsByConfig = (payload: ConfigPayloadEntity) => {
  const { inputType, customKey, dataConfig, options, isPreventCustomConfig } =
    payload;

  const canCustomOpts =
    !!inputType &&
    TYPES_ALLOW_CUSTOM_OPTS.includes(inputType) &&
    !isPreventCustomConfig;

  /** We can customize the options if the following conditions are met
   * Whether @inputType props is included in the @TYPES_ALLOW_CUSTOM_OPTS list?
   */
  if (canCustomOpts) {
    const disabledKeys = dataConfig[customKey]?.disabledKeys ?? [];
    const removeKeys = dataConfig[customKey]?.removeKeys ?? [];
    const insertKeys = dataConfig[customKey]?.insertKeys ?? [];

    const addingOptions: DefaultOptionType[] = insertKeys.map(key => ({
      value: key,
      label: key,
    }));

    //Merge the customized options with insertKeys list from insertKeys config list and uniq this
    const expandOptions = unionBy(options ?? [], addingOptions, 'label');

    //Options can be disabled/removed from the list during transformation
    return expandOptions.reduce((accumulator, currOpt) => {
      // TODO: If the component use label props as an element, please remember to use id props into that option item
      const transformKey: string = currOpt?.id ?? currOpt.label ?? '';

      if (!removeKeys.includes(transformKey)) {
        accumulator.push({
          ...currOpt,
          label: (
            <span data-customization-key={transformKey}>{currOpt.label}</span>
          ),
          disabled: disabledKeys.includes(transformKey) || currOpt.disabled,
        });
      }

      return accumulator;
    }, [] as DefaultOptionType[]);
  }

  return options;
};
